// extracted by mini-css-extract-plugin
export var quantityInput = "_pv-0";